module.exports = __webpack_public_path__ + "static/media/narwhal.c5073ca0.svg";